export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  author: string;
  authorAvatar: string;
  date: string;
  readTime: string;
  image: string;
  tags: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '京城周边最美的十条徒步路线，这个周末就出发',
    excerpt: '从香山到长城，从密云到怀柔，我们为你精选了北京周边最适合周末出行的徒步路线，让你在自然中找回内心的平静。',
    content: `<p>在快节奏的都市生活中，越来越多的人开始向往户外，渴望在周末逃离钢筋水泥的包围，到山野间呼吸新鲜空气。北京作为一座被群山环抱的城市，周边拥有丰富的徒步资源。</p>
    <h2>为什么越来越多人爱上徒步？</h2>
    <p>徒步不仅是一项锻炼身体的运动，更是一种与自己对话的方式。当你走在山间小路上，听着鸟鸣和风声，城市的喧嚣仿佛被远远抛在身后。对于17c一起社区的很多成员来说，徒步已经成为每周末必不可少的活动。</p>
    <p>数据显示，过去两年参加户外徒步活动的年轻人数量增长了超过200%。这其中很重要的一个原因就是社交需求——徒步为人们提供了一个远离手机屏幕、面对面交流的机会。</p>
    <h2>推荐路线一：香山 - 植物园穿越线</h2>
    <p>这条线路全长约8公里，难度适中，非常适合初次尝试徒步的朋友。起点从香山公园东门出发，途经香炉峰，最后抵达北京植物园。沿途可以欣赏到四季不同的自然风光，尤其是秋季的红叶，美不胜收。</p>
    <p>推荐指数：★★★★★</p>
    <p>难度：★★☆☆☆</p>
    <p>预计耗时：3-4小时</p>
    <h2>推荐路线二：长城箭扣段</h2>
    <p>箭扣长城是长城中最具野性魅力的一段，蜿蜒盘旋于崇山峻岭之间。这条路线对体能有一定要求，但沿途的风景绝对值得付出。在17c一起社区，我们经常组织箭扣长城的团体徒步，大家一起互相鼓励、共同攀登。</p>
    <p>推荐指数：★★★★★</p>
    <p>难度：★★★★☆</p>
    <p>预计耗时：5-6小时</p>
    <h2>徒步小贴士</h2>
    <p>出发前记得准备充足的水和食物，穿着舒适的徒步鞋，最好结伴同行。17c一起社区每周都有徒步活动发布，欢迎加入我们一起探索大自然的美好！</p>`,
    category: '户外运动',
    categorySlug: 'outdoor',
    author: '山野行者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20friendly%20smile%2C%20outdoor%20casual%20style%2C%20warm%20natural%20lighting%2C%20minimal%20clean%20background%2C%20professional%20headshot%20style&width=100&height=100&seq=author-avatar-1&orientation=squarish',
    date: '2026-08-02',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20mountain%20hiking%20trail%20near%20Beijing%20with%20autumn%20foliage%2C%20group%20of%20hikers%20in%20distance%2C%20warm%20golden%20sunlight%2C%20clear%20blue%20sky%2C%20natural%20landscape%20photography%2C%20clean%20editorial%20style&width=1200&height=600&seq=article-outdoor-1&orientation=landscape',
    tags: ['徒步', '户外', '北京周边', '周末活动'],
    featured: true,
  },
  {
    id: 'article-2',
    title: '零基础也能学会的尤克里里，三个月弹唱体验分享',
    excerpt: '从完全不会乐器到能够弹唱简单的歌曲，只需要三个月的时间。来看看社区里小伙伴的尤克里里学习之路。',
    content: `<p>音乐是连接心灵的桥梁。在17c一起社区的音乐小组里，尤克里里是最受欢迎的入门乐器之一。它体积小巧、携带方便、上手容易，非常适合音乐初学者。</p>
    <h2>为什么选择尤克里里？</h2>
    <p>尤克里里只有四根弦，和弦指法相对简单，即使是完全没有乐理基础的人也能在短时间内弹出悦耳的旋律。而且它的音色明亮温暖，弹奏起来让人心情愉悦。</p>
    <p>在17c一起社区，我们每周都有尤克里里交流活动，大家聚在一起分享新学的曲目，互相鼓励和学习。这种集体学习的氛围让坚持变得更容易。</p>
    <h2>三个月的学习计划</h2>
    <p>第一个月：掌握基本持琴姿势、调音方法和C、Am、F、G四个基础和弦。可以弹奏《小星星》《生日快乐》等简单曲目。</p>
    <p>第二个月：学习更多的和弦以及基础的扫弦节奏型。尝试弹唱《旅行的意义》《成都》等慢节奏歌曲。</p>
    <p>第三个月：练习复杂的节奏型和指弹技巧。可以和社区里的小伙伴一起合奏，体验音乐协作的快乐。</p>
    <h2>社区音乐活动的魅力</h2>
    <p>一个人学乐器容易半途而废，但一群人一起学就会变得有趣而持久。来17c一起的音乐小组，找到和你志同道合的音乐伙伴吧！</p>`,
    category: '音乐艺术',
    categorySlug: 'music',
    author: '音符旅人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20warm%20smile%2C%20artistic%20style%2C%20natural%20lighting%2C%20minimal%20clean%20background%2C%20professional%20headshot&width=100&height=100&seq=author-avatar-2&orientation=squarish',
    date: '2026-08-01',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Closeup%20of%20ukulele%20on%20wooden%20table%20with%20warm%20sunlight%20through%20window%2C%20music%20sheet%20nearby%2C%20cozy%20indoor%20atmosphere%2C%20minimal%20aesthetic%2C%20soft%20golden%20light%2C%20clean%20editorial%20style&width=1200&height=600&seq=article-music-1&orientation=landscape',
    tags: ['乐器', '尤克里里', '音乐', '入门'],
    featured: true,
  },
  {
    id: 'article-3',
    title: '周末烘焙课：手把手教你做完美的提拉米苏',
    excerpt: '不需要烤箱，只需要简单的材料和一点点耐心，就能在家做出餐厅级别的经典提拉米苏。',
    content: `<p>提拉米苏，这道源自意大利的经典甜点，以它丝滑细腻的口感和咖啡与可可的完美融合征服了无数人的味蕾。在17c一起美食小组的烘焙活动中，提拉米苏一直是最受欢迎的课程之一。</p>
    <h2>准备材料</h2>
    <p>马斯卡彭芝士250克、鸡蛋3个、细砂糖60克、手指饼干适量、浓缩咖啡200毫升、可可粉适量、朗姆酒少许（可选）。</p>
    <h2>制作步骤</h2>
    <p>第一步：分离蛋黄和蛋白。将蛋黄与一半的糖打发至颜色变浅、体积膨大，然后加入马斯卡彭芝士搅拌均匀。</p>
    <p>第二步：蛋白与剩余糖打发至硬性发泡，然后分次拌入芝士糊中，注意要用翻拌的手法，避免消泡。</p>
    <p>第三步：将手指饼干快速浸入浓缩咖啡中，铺在容器底部，然后铺一层芝士糊，重复这个步骤直到材料用完。</p>
    <p>第四步：放入冰箱冷藏至少4小时，食用前筛上可可粉即可。</p>
    <h2>社群烘焙的乐趣</h2>
    <p>在17c一起的烘焙活动中，大家围在一起动手制作，分享各自的烘焙心得，这种面对面的社交体验是线上无法替代的。每次活动结束后，我们还会把多余的甜点分享给周围的邻居，传递甜蜜和温暖。</p>`,
    category: '美食烹饪',
    categorySlug: 'food',
    author: '甜点达人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%2C%20cheerful%20expression%2C%20casual%20apron%20style%2C%20warm%20lighting%2C%20minimal%20clean%20background%2C%20professional%20headshot&width=100&height=100&seq=author-avatar-3&orientation=squarish',
    date: '2026-07-30',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20homemade%20tiramisu%20in%20ceramic%20dish%20with%20cocoa%20powder%20on%20wooden%20table%2C%20warm%20natural%20light%2C%20cozy%20kitchen%20setting%2C%20minimal%20food%20photography%20style%2C%20soft%20shadows&width=1200&height=600&seq=article-food-1&orientation=landscape',
    tags: ['烘焙', '甜点', '提拉米苏', '美食'],
    featured: true,
  },
  {
    id: 'article-4',
    title: '每月共读一本书：八月推荐书单及读书会安排',
    excerpt: '17c一起读书会的八月精选书单来了！从文学经典到商业思维，总有一本适合你。',
    content: `<p>阅读是一场与智者的对话，而共读则让这场对话变得更加丰富和多元。17c一起社区的读书会已经陪伴大家走过了大半年的时光，每一期的共读都让我们收获满满。</p>
    <h2>八月共读书目：《百年孤独》</h2>
    <p>加西亚·马尔克斯的魔幻现实主义巨作，讲述布恩迪亚家族七代人的传奇故事。这本书不仅是拉丁美洲文学的巅峰之作，更是一部关于人类命运的宏大叙事。</p>
    <p>读书会将于8月15日和8月29日各举行一次线下讨论，欢迎所有读过或正在读这本书的朋友参加。不用担心读不完，我们鼓励大家分享任何阶段的感悟。</p>
    <h2>推荐书单</h2>
    <p>除了共读书目外，本月还有三本推荐书目：</p>
    <p>《被讨厌的勇气》——用阿德勒心理学重新审视人际关系和自我价值。</p>
    <p>《思考，快与慢》——诺贝尔经济学奖得主卡尼曼的经典之作，帮助你更好地理解人类决策机制。</p>
    <p>《活着》——余华的经典小说，在平凡的文字中感受生命的厚重。</p>
    <h2>加入读书会</h2>
    <p>17c一起读书会每周都有小组讨论活动，无论你是文学爱好者还是想要培养阅读习惯的新手，都能在这里找到属于你的阅读伙伴。</p>`,
    category: '读书学习',
    categorySlug: 'reading',
    author: '书虫小姐',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20gentle%20smile%2C%20wearing%20glasses%2C%20intellectual%20style%2C%20warm%20lighting%2C%20minimal%20clean%20background%2C%20professional%20headshot&width=100&height=100&seq=author-avatar-4&orientation=squarish',
    date: '2026-07-28',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Stack%20of%20books%20with%20coffee%20cup%20on%20wooden%20desk%20near%20window%2C%20warm%20natural%20light%2C%20cozy%20reading%20nook%2C%20minimal%20aesthetic%2C%20soft%20shadows%2C%20clean%20editorial%20style&width=1200&height=600&seq=article-reading-1&orientation=landscape',
    tags: ['读书', '书单', '读书会', '文学'],
    featured: false,
  },
  {
    id: 'article-5',
    title: '桌游之夜：五款最适合新手的聚会游戏推荐',
    excerpt: '不知道周末聚会玩什么？这五款入门级桌游让你和朋友的笑声停不下来。',
    content: `<p>在17c一起社区的桌游小组里，每周五晚上都是最热闹的时候。大家带着自己喜欢的桌游来到活动室，一玩就是几个小时。对于刚接触桌游的朋友来说，选择一款容易上手又有趣的游戏很重要。</p>
    <h2>推荐一：阿瓦隆</h2>
    <p>一款经典的社交推理游戏，玩家分为正义和邪恶两方，通过言语交流和逻辑推理来实现各自的目标。规则简单但策略深度十足，非常适合5-10人的聚会。</p>
    <h2>推荐二：璀璨宝石</h2>
    <p>一款精美的资源收集类桌游，玩家扮演文艺复兴时期的宝石商人，通过收集宝石来发展自己的商业帝国。规则五分钟就能学会，但想赢需要精妙的策略。</p>
    <h2>推荐三：画物语</h2>
    <p>一款充满想象力的猜词游戏，玩家需要用抽象的图画来表达指定的词语。这款游戏最大的乐趣在于——当你发现朋友的脑回路和你完全不同时的爆笑场面。</p>
    <h2>加入桌游小组</h2>
    <p>17c一起桌游小组每周五晚固定活动，我们提供数十款热门桌游，你也可以带自己喜欢的游戏来分享。无论你是桌游老手还是新手，都欢迎加入！</p>`,
    category: '游戏电竞',
    categorySlug: 'gaming',
    author: '桌游队长',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20enthusiastic%20smile%2C%20casual%20style%2C%20warm%20lighting%2C%20minimal%20clean%20background%2C%20professional%20headshot&width=100&height=100&seq=author-avatar-5&orientation=squarish',
    date: '2026-07-25',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Friends%20playing%20colorful%20board%20games%20around%20wooden%20table%2C%20warm%20evening%20lighting%2C%20cozy%20indoor%20setting%2C%20laughing%20expressions%2C%20minimal%20aesthetic%2C%20editorial%20social%20photography&width=1200&height=600&seq=article-gaming-1&orientation=landscape',
    tags: ['桌游', '聚会', '游戏', '社交'],
    featured: false,
  },
  {
    id: 'article-6',
    title: '一个人的旅行太孤单？试试结伴同游的N种方式',
    excerpt: '想旅行却找不到同伴？17c一起社区的结伴旅行功能让你的旅途不再孤单。',
    content: `<p>旅行是探索世界最好的方式，但独自旅行有时难免会感到孤单。在17c一起社区，我们相信好的旅行需要好的同伴。通过我们的平台，已经有数千名用户找到了志同道合的旅行伙伴。</p>
    <h2>方式一：兴趣匹配</h2>
    <p>在17c一起上填写你的旅行偏好——想去的目的地、预算范围、旅行风格（穷游/舒适/豪华）、感兴趣的体验类型——系统会自动为你推荐匹配的旅伴。</p>
    <h2>方式二：主题旅行团</h2>
    <p>加入由社区达人发起的主题旅行团，比如摄影之旅、美食探访、古镇漫步等。这些旅行团通常规模在6-12人，既能保证社交体验，又不会过于拥挤。</p>
    <h2>方式三：城市周末游</h2>
    <p>如果你时间有限，也可以参加我们每周的城市周边周末游。这些活动通常是一天或两天的短途旅行，非常适合初次尝试结伴旅行的人。</p>
    <h2>真实故事</h2>
    <p>社区成员小林分享道："通过17c一起，我找到了三个和我一样热爱古镇摄影的朋友。上个月我们一起去了一趟乌镇，拍了无数张好照片，还成了很好的朋友。"</p>`,
    category: '旅行探险',
    categorySlug: 'travel',
    author: '背包客小陈',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20adventurous%20look%2C%20outdoor%20style%2C%20warm%20natural%20lighting%2C%20minimal%20clean%20background%2C%20professional%20headshot&width=100&height=100&seq=author-avatar-6&orientation=squarish',
    date: '2026-07-22',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Group%20of%20young%20travelers%20with%20backpacks%20walking%20through%20ancient%20Chinese%20water%20town%2C%20reflection%20in%20canal%2C%20warm%20golden%20afternoon%20light%2C%20traditional%20architecture%2C%20editorial%20travel%20photography&width=1200&height=600&seq=article-travel-1&orientation=landscape',
    tags: ['旅行', '结伴', '攻略', '周末游'],
    featured: false,
  },
  {
    id: 'article-7',
    title: '手机摄影入门：掌握这五个技巧，照片质感瞬间提升',
    excerpt: '不需要昂贵的器材，用好手中的手机，你也能拍出令人惊艳的照片。',
    content: `<p>在人人都是摄影师的时代，手机摄影已经成为记录生活最重要的方式。但为什么同样是手机拍照，有的人拍出来像艺术品，有的人拍出来却平平无奇？关键就在于是否掌握了一些基础的摄影技巧。</p>
    <h2>技巧一：光线是灵魂</h2>
    <p>拍照的本质是记录光线。黄金时段——日出后一小时和日落前一小时——的自然光最为柔和温暖，是拍摄的最佳时间。尽量避免在正午强光下拍摄，那会产生难看的阴影。</p>
    <h2>技巧二：构图三分法</h2>
    <p>打开手机的网格线功能，将画面横竖各分为三等份。把主体放在交叉点上，会比放在正中央更有视觉张力。这是最基础也最有效的构图技巧。</p>
    <h2>技巧三：寻找引导线</h2>
    <p>道路、栏杆、河流、建筑的线条都可以成为引导线，把观众的视线引导到你想要突出的主体上。</p>
    <h2>加入17c一起摄影小组</h2>
    <p>我们每周都有线下摄影活动，从城市街拍到野外采风，在实践中提升摄影技巧。更重要的是，你还能结识一群同样热爱摄影的朋友！</p>`,
    category: '摄影影像',
    categorySlug: 'photography',
    author: '光影捕手',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%2C%20creative%20look%2C%20holding%20camera%2C%20artistic%20style%2C%20warm%20lighting%2C%20minimal%20clean%20background%2C%20professional%20headshot&width=100&height=100&seq=author-avatar-7&orientation=squarish',
    date: '2026-07-20',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20photography%20setup%20on%20minimal%20desk%2C%20warm%20natural%20light%20through%20window%2C%20creative%20atmosphere%2C%20clean%20aesthetic%2C%20soft%20shadows%2C%20editorial%20product%20photography%20style&width=1200&height=600&seq=article-photography-1&orientation=landscape',
    tags: ['摄影', '手机摄影', '技巧', '入门'],
    featured: false,
  },
  {
    id: 'article-8',
    title: '居家健身指南：每天15分钟的高效燃脂训练',
    excerpt: '不去健身房也能高效燃脂！这套居家训练计划适合所有健身水平的人。',
    content: `<p>忙碌的生活节奏让很多人难以坚持去健身房。但其实，只要掌握正确的方法，在家也能进行高效的健身训练。17c一起健身小组的教练为大家设计了一套每天只需15分钟的居家燃脂方案。</p>
    <h2>训练计划</h2>
    <p>每个动作做40秒，休息20秒，共完成3个循环。总耗时约15分钟。</p>
    <p>动作一：开合跳——全身热身，激活心肺</p>
    <p>动作二：深蹲——锻炼下半身大肌群</p>
    <p>动作三：俯卧撑（可膝盖着地降低难度）——锻炼胸部和手臂</p>
    <p>动作四：登山者——核心训练和心肺结合</p>
    <p>动作五：平板支撑——核心稳定性训练</p>
    <h2>社群打卡的力量</h2>
    <p>在17c一起健身小组，我们鼓励每天打卡分享训练成果。看到其他小伙伴的坚持，自己也会更有动力。很多成员表示，加入社群后健身坚持率从不到30%提升到了80%以上。</p>
    <h2>加入我们</h2>
    <p>17c一起健身小组每周有线上打卡挑战和线下团体训练活动，欢迎所有想要健康生活的朋友加入！</p>`,
    category: '健身运动',
    categorySlug: 'fitness',
    author: '运动达人K',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%2C%20athletic%20look%2C%20friendly%20smile%2C%20sportswear%2C%20warm%20lighting%2C%20minimal%20clean%20background%2C%20professional%20headshot&width=100&height=100&seq=author-avatar-8&orientation=squarish',
    date: '2026-07-18',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Bright%20modern%20living%20room%20with%20yoga%20mat%20and%20small%20weights%2C%20warm%20natural%20sunlight%2C%20minimal%20interior%2C%20clean%20fresh%20atmosphere%2C%20editorial%20lifestyle%20photography&width=1200&height=600&seq=article-fitness-1&orientation=landscape',
    tags: ['健身', '居家', '燃脂', '健康'],
    featured: false,
  },
  {
    id: 'article-9',
    title: '露营初体验：装备清单和注意事项全攻略',
    excerpt: '第一次露营不知道要准备什么？这份详细的露营装备清单和注意事项帮你轻松开启露营之旅。',
    content: `<p>随着户外生活方式的流行，露营成为越来越多年轻人的周末选择。在17c一起户外运动小组，露营活动总是最快报满的项目之一。但对于没有露营经验的新手来说，第一次露营可能会有些手忙脚乱。</p>
    <h2>基础装备清单</h2>
    <p>帐篷：选择适合季节的三人帐或四人帐（即使是两人出行也建议选择大一号）</p>
    <p>睡袋：根据露营地的夜间温度选择合适温标的睡袋</p>
    <p>防潮垫：充气垫或蛋巢垫，直接影响睡眠质量</p>
    <p>照明：头灯或营地灯，头灯可以解放双手</p>
    <p>炊具：便携炉头、气罐、锅具和餐具</p>
    <h2>营地选择技巧</h2>
    <p>选择平坦、避风、远离水源泛滥区的位置。不要在大树下扎营，防止枯枝掉落。如果是在山区露营，注意不要在河道中扎营。</p>
    <h2>17c一起露营活动</h2>
    <p>对于露营新手，我们建议参加社区组织的团体露营活动。不仅有人指导搭建帐篷和使用装备，还能在篝火旁和新朋友分享故事。上个月的坝上草原露营活动，40多位社区成员一起看星空、烧烤，留下了美好回忆。</p>`,
    category: '户外运动',
    categorySlug: 'outdoor',
    author: '山野行者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20friendly%20smile%2C%20outdoor%20casual%20style%2C%20warm%20natural%20lighting%2C%20minimal%20clean%20background%2C%20professional%20headshot%20style&width=100&height=100&seq=author-avatar-1&orientation=squarish',
    date: '2026-07-15',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Tent%20camping%20setup%20in%20meadow%20with%20warm%20sunset%20light%2C%20campfire%20nearby%2C%20mountains%20in%20background%2C%20peaceful%20nature%20atmosphere%2C%20clean%20editorial%20style%2C%20warm%20golden%20tones&width=1200&height=600&seq=article-outdoor-2&orientation=landscape',
    tags: ['露营', '户外', '装备', '攻略'],
    featured: false,
  },
  {
    id: 'article-10',
    title: '水彩画入门：从零开始的色彩之旅',
    excerpt: '水彩画的魅力在于它的流动性和不可预测性。来17c一起艺术小组，和我们一起探索水彩的奇妙世界。',
    content: `<p>水彩画，一种以水为媒介的绘画方式，以其清新透明、层次丰富的特点深受艺术爱好者喜爱。在17c一起艺术小组的水彩课程中，我们见证了很多零基础的成员在短时间内创作出令人惊喜的作品。</p>
    <h2>为什么选择水彩？</h2>
    <p>水彩画的门槛相对较低——只需要几支颜料、几支画笔、一本水彩纸就可以开始创作。而且水彩的流动性让每一笔都充满惊喜，这种不可完全控制的特性反而让创作过程更加自由和有趣。</p>
    <h2>基础工具推荐</h2>
    <p>新手入门建议准备：一套12色固体水彩、一支大号平头笔、一支中号圆头笔、300克棉浆水彩纸（至少A5大小）。先不要买太贵的材料，等上手后再逐步升级。</p>
    <h2>第一次练习：湿画法天空</h2>
    <p>将水彩纸用水均匀打湿，然后用大笔蘸取蓝色和少量紫色，轻轻扫在纸面上，观察颜色在湿润纸面上自然扩散的奇妙效果。这就是水彩画最令人着迷的地方。</p>
    <h2>艺术小组活动</h2>
    <p>17c一起艺术小组每周日下午都有绘画交流活动，有时候在公园写生，有时候在咖啡馆室内创作。带上你的画笔，来和我们一起享受创作的快乐吧！</p>`,
    category: '音乐艺术',
    categorySlug: 'music',
    author: '色彩追梦人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20artistic%20look%2C%20warm%20smile%2C%20creative%20style%2C%20warm%20natural%20lighting%2C%20minimal%20clean%20background%2C%20professional%20headshot&width=100&height=100&seq=author-avatar-9&orientation=squarish',
    date: '2026-07-12',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Watercolor%20painting%20supplies%20on%20wooden%20desk%2C%20color%20palette%20with%20soft%20pastel%20colors%2C%20warm%20natural%20light%2C%20creative%20artistic%20atmosphere%2C%20minimal%20aesthetic%2C%20clean%20editorial%20style&width=1200&height=600&seq=article-music-art-2&orientation=landscape',
    tags: ['水彩', '绘画', '艺术', '入门'],
    featured: false,
  },
];

export const getArticleById = (id: string) => {
  return articles.find((a) => a.id === id);
};

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter((a) => a.categorySlug === categorySlug);
};

export const getFeaturedArticles = () => {
  return articles.filter((a) => a.featured);
};

export const getRelatedArticles = (article: Article, limit: number = 3) => {
  return articles
    .filter((a) => a.id !== article.id && a.categorySlug === article.categorySlug)
    .slice(0, limit);
};